import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { UsersDashboardQueryKeys } from "modules/UsersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

type UpdateDevicePayload = {
  device_id: number;
  is_leased: boolean;
};

export const useUpdateDeviceMutation = () =>
  useTypedMutation({
    mutationFn: async (payload: UpdateDevicePayload) => (await ApiInstance.post(`/devices/lease/update`, payload, ENV.systemBaseURL)).data,
    onSuccess: ({ device_id, is_leased }) => {
      const prevDevices = typedQueryClient.getQueryData(UsersDashboardQueryKeys.devices);
      if (!prevDevices) return;

      const deviceIdx = prevDevices.findIndex(device => device.id === device_id);
      if (deviceIdx === -1) return;

      typedQueryClient.setQueryData(UsersDashboardQueryKeys.devices, prevDevices.with(deviceIdx, { ...prevDevices[deviceIdx], is_leased }));
    }
  });
